import _ from 'lodash'

interface Node {
  children: Node[]
}

/**
 * 遍历树节点
 */
export function each<T extends Node>(
  node: T | T[],
  callback: (item: T) => void
): void {
  if (node) {
    if (Array.isArray(node)) {
      _.each(node, (item) => {
        each(item, callback)
      })
    } else {
      callback(node)
      if (node.children && node.children.length > 0) {
        _.each(node.children, (item) => {
          each<T>(item as T, callback)
        })
      }
    }
  }
}
